import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import {ContextConsumer} from '../Context'

const styles = {
  block: {
    position: 'absolute',
    top: 70,
    left: '50%',
    transform: 'translateX(-50%)',
    borderRadius: 20,
    fontSize: 20,
    textAlign: 'center',
    color: 'white',
  },
}

const ShowFrameSize = ({classes}) => {
  return (
    <ContextConsumer>
      {context => {
        const {innerHeight, innerWidth} = window
        const {frameHeight, frameWidth} = context
        let background = 'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.7))'

        if (innerHeight - 80 < frameHeight) {
          background = 'linear-gradient(rgba(255,0,0,0.5), rgba(255,0,0,0.7))'
        }
        if (innerWidth < frameWidth) {
          background =
            'linear-gradient(rgba(200,0,200,0.5), rgba(200,0,200,0.7))'
        }
        return (
          <div
            className={classes.block}
            style={{
              height: frameHeight,
              width: frameWidth,
              background,
            }}>
            iFrame size preview
          </div>
        )
      }}
    </ContextConsumer>
  )
}

ShowFrameSize.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {withTheme: true})(ShowFrameSize)



// WEBPACK FOOTER //
// ./src/components/ShowFrameSize.js